// extracted by mini-css-extract-plugin
export default {"div":"Catalogue_div__tWJfp","card":"Catalogue_card__D6Iar","cards":"Catalogue_cards__x5B2g"};